<template>
  <div>
    <!-- Form element that submits all the data in the form to Firebase using the submitData method -->
    <form @submit.prevent="$emit('form-submit', form, day)">
      <!-- Add form fields here, wrapped in a div with a class of field -->
      <div class="field">
        <p>Sexual activity today</p>
        <div class="radio">
          <input
            type="radio"
            id="none"
            value="none"
            name="sexual-activity"
            v-model="form.sexualActivity"
          />
          <label for="none">None</label>
        </div>

        <div class="radio">
          <input
            type="radio"
            id="external/clitoral"
            value="external/clitoral"
            name="sexual-activity"
            v-model="form.sexualActivity"
          />
          <label for="external/clitoral">External / Clitoral</label>
        </div>

        <div class="radio">
          <input
            type="radio"
            id="internal/vaginal"
            value="internal/vaginal"
            name="sexual-activity"
            v-model="form.sexualActivity"
          />
          <label for="internal/vaginal">Internal / Vaginal</label>
        </div>

        <div class="radio">
          <input
            type="radio"
            id="other"
            value="other"
            name="sexual-activity"
            v-model="form.sexualActivity"
          />
          <label for="other">Other</label>
        </div>
      </div>

      <div class="field">
        <div class="checkbox">
          <input
            type="checkbox"
            name="avoided"
            id="avoided"
            v-model="form.avoidedSex"
          />
          <label for="avoided"
            >Avoided sexual activity today because of pain</label
          >
        </div>
      </div>

      <div class="field">
        <div class="checkbox">
          <input
            type="checkbox"
            name="avoided"
            id="interrupted"
            v-model="form.interruptedSex"
          />
          <label for="interrupted"
            >Interrupted or stopped sexual activity today because of pain</label
          >
        </div>
      </div>

      <fieldset>
        <legend>During sexual activity today</legend>

        <div class="field">
          <p>Pain overall during</p>
          <Radios
            name="during-overall"
            :entry="existingEntry"
            @store-number="storeDuringOverall"
            data="duringOverall"
            amount="11"
          />
        </div>

        <div class="field">
          <p>Pain externally (vulva, clitoris)</p>
          <Radios
            name="during-external"
            :entry="existingEntry"
            @store-number="storeDuringExternal"
            data="duringExternal"
            amount="11"
          />
        </div>

        <div class="field">
          <p>Pain in lower vagina</p>
          <Radios
            name="during-lower"
            :entry="existingEntry"
            @store-number="storeDuringLower"
            data="duringLower"
            amount="11"
          />
        </div>

        <div class="field">
          <p>Pain in upper vagina or deep pelvis</p>
          <Radios
            name="during-upper"
            :entry="existingEntry"
            @store-number="storeDuringUpper"
            data="duringUpper"
            amount="11"
          />
        </div>
      </fieldset>

      <fieldset>
        <legend>After sexual activity</legend>

        <div class="field">
          <p>Pain overall after</p>
          <Radios
            name="after-overall"
            :entry="existingEntry"
            @store-number="storeAfterOverall"
            data="afterOverall"
            amount="11"
          />
        </div>

        <div class="field">
          <p>Pain externally (vulva, clitoris)</p>
          <Radios
            name="after-external"
            :entry="existingEntry"
            @store-number="storeAfterExternal"
            data="afterExternal"
            amount="11"
          />
        </div>

        <div class="field">
          <p>Pain in lower vagina</p>
          <Radios
            name="after-lower"
            :entry="existingEntry"
            @store-number="storeAfterLower"
            data="afterLower"
            amount="11"
          />
        </div>

        <div class="field">
          <p>Pain in upper vagina or deep pelvis</p>
          <Radios
            name="after-upper"
            :entry="existingEntry"
            @store-number="storeAfterUpper"
            data="afterUpper"
            amount="11"
          />
        </div>
      </fieldset>

      <div class="field">
        <button class="button button--standard" type="submit">
          <span v-if="day.edit">Update</span>
          <span v-else>Log your sexual function</span>
        </button>
        <button
          class="button button--danger"
          v-if="day.edit"
          @click.prevent="$emit('cancel-edit', day)"
        >
          Cancel
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import Radios from "@/components/Radios.vue";

export default {
  name: "Form",
  props: ["existingEntry", "day"],
  components: { Radios },

  methods: {
    storeDuringOverall(level) {
      this.form.duringOverall = level;
    },
    storeDuringExternal(level) {
      this.form.duringExternal = level;
    },
    storeDuringLower(level) {
      this.form.duringLower = level;
    },
    storeDuringUpper(level) {
      this.form.duringUpper = level;
    },
    storeAfterOverall(level) {
      this.form.afterOverall = level;
    },
    storeAfterExternal(level) {
      this.form.afterExternal = level;
    },
    storeAfterLower(level) {
      this.form.afterLower = level;
    },
    storeAfterUpper(level) {
      this.form.afterUpper = level;
    },
  },

  data() {
    return {
      form: {
        // Add form field data here. This data will be submitted to Firestore and
        // should match the v-model values from your form fields.
        sexualActivity: this.existingEntry
          ? this.existingEntry.data.sexualActivity
          : "",
        avoidedSex: this.existingEntry
          ? this.existingEntry.data.avoidedSex
          : false,
        interruptedSex: this.existingEntry
          ? this.existingEntry.data.interruptedSex
          : false,
      },
    };
  },
};
</script>

<style>
button {
  margin-right: 1rem;
}

fieldset {
  margin-bottom: 2rem;
}

.checkbox,
.radio {
  align-items: center;
  display: flex;
  margin-bottom: 0.5rem;
}

.checkbox input,
.radio input {
  height: auto;
  margin: 0 0.5rem 0 0;
}
</style>
